import { NavBar } from '@teko/teko-ecommerce';
import { HeadSection } from 'components/HeadSection';
import { MobileLayout } from 'components/Layout/MobileLayout';
import { NavBarDropdownMenu } from 'components/mobile/organisms/NavBarDropdownMenu';
import { HamperProvider } from 'contexts';
import { useRouter } from 'next/router';
import React from 'react';
import { PbServerSideProps } from '../getServerSideProps';
import { PbPage } from '../page';

export const PageBuilderMobile: React.FC<PbServerSideProps> = (props) => {
  const { pbMetaData, name } = props;
  const router = useRouter();
  return (
    <MobileLayout
      navbar={
        <NavBar
          title={name}
          goBack={() => {
            router.back();
          }}
          dropdownMenu={<NavBarDropdownMenu />}
        />
      }
    >
      <HeadSection
        title={pbMetaData.metaTitle || name}
        metaTitle={pbMetaData.metaTitle}
        description={pbMetaData.metaDescription}
        canonical={pbMetaData.canonical}
        noindex={pbMetaData.noIndex}
        keywords={pbMetaData.metaKeywords?.join(',')}
        image={pbMetaData.metaImage}
      />
      <HamperProvider>
        <PbPage {...props} page={router.query.slug as string} />
      </HamperProvider>
    </MobileLayout>
  );
};
